// @flow

import type { EmployeeBranchPosition, ThirdPartyEmployeeEmployee } from '../types';

import type { EmployeesFilterParams } from '../../containers/Employees/Filter';
import type { FetchListParams, ListResponse } from './index';
import {
  downloadRequestWithToken,
  fetchRequest,
  initialFetchListParams
} from './index';

export const addEmployee = async (employee: ThirdPartyEmployeeEmployee): Promise<ThirdPartyEmployeeEmployee> => {
  const added = await fetchRequest.post('/ThirdPartyEmployee', employee);
  if (added) return added;
  throw new Error('Не удалось создать сотрудника');
};

export const updateEmployee = async (employee: ThirdPartyEmployeeEmployee): Promise<ThirdPartyEmployeeEmployee> => {
  const updated = await fetchRequest.put('/ThirdPartyEmployee', employee);
  if (updated) return updated;
  throw new Error('Не удалось обновить сотрудника');
};

export const fetchEmployee = async (
  id: number,
  params: any = {}
): Promise<ThirdPartyEmployeeEmployee> => {
  let employee = await fetchRequest.get(`/ThirdPartyEmployee/${id}`, params);
  if (employee) return employee;
  throw new Error('Не удалось загрузить сотрудника');
};

export const fetchEmployees = async (
  params: FetchListParams<EmployeesFilterParams> = initialFetchListParams
): Promise<ListResponse<ThirdPartyEmployeeEmployee>> =>
  await fetchRequest.get('/ThirdPartyEmployee', {
    ...initialFetchListParams,
    ...params
  });

export const fetchEmployeesMainEngineer = async (
  params: FetchListParams
): Promise<ListResponse<ThirdPartyEmployeeEmployee>> => await fetchRequest.get('/ThirdPartyEmployee/gpmEmployee', params);

export const deleteEmployee = async (id: number): Promise<ThirdPartyEmployeeEmployee> => {
  const deleted = await fetchRequest.delete(`/ThirdPartyEmployee/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить сотрудника');
};

export const print = async (params: FetchListParams<EmployeesFilterParams>) => {
  const printed = await downloadRequestWithToken('/ThirdPartyEmployee/print', params);
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

export const fetchBranchEmployeesPositions = async (
  branchId: number
): Promise<EmployeeBranchPosition[]> => {
  return await fetchRequest.get(`/ThirdPartyEmployee/branchEmployees/${branchId}`, {});
};

export const fetchSimpleEmployeesPositions = async (
  params: FetchListParams<EmployeesFilterParams> = initialFetchListParams
): Promise<ListResponse<String>> =>
  await fetchRequest.get('/ThirdPartyEmployee/getPositions', {
    ...initialFetchListParams,
    ...params
  });

  export const getCompany = async (id: number, params: any): Promise<Company> => {
    const data = await fetchRequest.get(`/ThirdPartyEmployee/Companies/${id}`, params);
    if (data)
      return data
    throw new Error(`Не удалось получить ${this.name}`);
  };

  export const fetchCompanies = async (
    params: FetchListParams<{}> = initialFetchListParams
  ): Promise<ListResponse<Company>> => {
    const findData = await fetchRequest.get(`/ThirdPartyEmployee/Companies`, {
      ...initialFetchListParams,
      ...params
    });
    if (findData) {
      return findData
    }
    throw new Error(`Не удалось получить ${this.name}`);
  };

export default {
  addEmployee,
  updateEmployee,
  fetchEmployees,
  fetchEmployeesMainEngineer,
  fetchEmployee,
  deleteEmployee,
  print,
  fetchBranchEmployeesPositions,
  fetchSimpleEmployeesPositions,
  getCompany,
  fetchCompanies,
};
